import {
	Typography,
	Toolbar,
	Paper,
	StepLabel,
	StepButton,
	Step,
	Stepper,
	Button,
} from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import CoAppCurrentEmploymentFields from 'features/ApplicationEntry/CoAppCurrentEmploymentFields';
import CoAppCurrentResidenceFields from 'features/ApplicationEntry/CoAppCurrentResidenceFields';
import CoAppPersonalInformationFields from 'features/ApplicationEntry/CoAppPersonalInformationFields';
import CurrentEmploymentFields from 'features/ApplicationEntry/CurrentEmploymentFields';
import CurrentResidenceFields from 'features/ApplicationEntry/CurrentResidenceFields';
import EditIcon from '@material-ui/icons/Edit';
import PersonalInformationFields from 'features/ApplicationEntry/PersonalInformationFields';
import PersonalReferenceFields from 'features/ApplicationEntry/PersonalReferenceFields';
import PreviousEmploymentFields from 'features/ApplicationEntry/PreviousEmploymentFields';
import PreviousResidenceFields from 'features/ApplicationEntry/PreviousResidenceFields';
import { BrowserView, MobileView } from 'react-device-detect';
import React, { useEffect } from 'react';
import removeHTML from 'shared/utils/removeHTML';
import { FieldArray } from 'redux-form';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
	APP_TYPE_CUSTOMER_JOINT,
	COAPP_CURRENT_EMPLOYMENT_STATUS_FIELDS,
	COAPP_CURRENT_RESIDENCE_STATUS_FIELDS,
	COAPP_SETTING,
	CURRENT_EMPLOYMENT_STATUS_FIELDS,
	CURRENT_RESIDENCE_STATUS_FIELDS,
	PERSONAL_REFERENCES,
	PERSONAL_REFERENCE_STATUS_FIELDS,
	PREVIOUS_EMPLOYMENT_STATUS_FIELDS,
	PREVIOUS_RESIDENCE_STATUS_FIELDS,
	PRIMARY_SETTING,
} from 'features/ApplicationEntry/constants';
import theme from 'shared/themes/storis';
import base64 from 'react-native-base64';
import withRouter from 'shared/utils/WithRouter';

export const styles = {
	editButton: {
		position: 'fixed',
		bottom: '40px',
		right: '40px',
		zIndex: '3',
	},
	editButtonMobile: {
		position: 'fixed',
		bottom: '10px',
		right: '10px',
		zIndex: '3',
	},
	panelDiv: {
		width: '95%',
		maxWidth: '800px',
		margin: 'auto',
	},
	paper: {
		width: '95%',
		maxWidth: '800px',
		height: 'auto',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '8px',
	},
	paperDiv: {
		padding: '25px',
	},
	reviewTitle: {
		display: 'inline',
		verticalAlign: 'middle',
	},
	sectionDiv: {
		border: '2px solid #aaa',
		padding: '20px',
		marginBottom: '5px',
	},
	stepper: {
		backgroundColor: '#FFFFFF',
		width: '95%',
		height: 'auto',
		maxWidth: '800px',
		marginTop: '8px',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	topButtons: {
		display: 'flex',
		justifyContent: 'flex-end',
		flexShrink: '0',
	},
	buttonToolbar: {
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		position: 'sticky',
		top: '0',
		backgroundColor: '#FFFFFF',
		marginBottom: '8px',
		zIndex: '2',
		fallbacks: {
			position: '-webkit-sticky',
		},
	},
	mobileStepIndicator: {
		marginLeft: '16px',
		marginTop: '-8px',
		color: theme.palette.primary.main,
		display: 'inline-block',
		position: 'absolute',
		left: '0',
	},
	headerLogo: {
		height: '100%',
		textAlign: 'center',
	},
	logoImg: {
		objectFit: 'contain',
		height: '100%',
		width: '100%',
	},
};

const renderReferences = ({ classes, fields, settings }) =>
	fields.map((member, index) => (
		// eslint-disable-next-line react/no-array-index-key
		<div className={classes.sectionDiv} key={index}>
			<Typography type="title" gutterBottom>
				Personal Reference {index + 1}
			</Typography>
			<PersonalReferenceFields disableAll settings={settings} member={member} index={index} />
		</div>
	));

const sectionNeeded = (properties, primaryOrCoApp, settings) => {
	const foundOne = properties.some(
		element =>
			settings[primaryOrCoApp][element].fieldStatus === 'O' ||
			settings[primaryOrCoApp][element].fieldStatus === 'M',
	);
	return foundOne;
};

function ApplicationReview(props) {
	const {
		history,
		classes,
		formValues,
		openCancelConfirmModal,
		settings,
		applicantIndicator,
		setApplicationFormData,
		userConsented,
	} = props;

	useEffect(() => {
		if (settings === undefined) {
			props.router.navigate('/now');
		}
		window.scrollTo(0, 0);
		formValues.userConsented = userConsented;
		setApplicationFormData(base64.encode(JSON.stringify(formValues)));
	}, []);

	// Don't display until settings have loaded
	if (settings === undefined) {
		return null;
	}
	return settings.primary != null ? (
		<form>
			<MobileView>
				<div className={classes.buttonToolbar}>
					<Toolbar className={classes.topButtons}>
						<div className={classes.headerLogo}>
							<img alt="logo" id="header-logo-image" className={classes.logoImg} />
						</div>
					</Toolbar>
				</div>
			</MobileView>
			<div className={classes.buttonToolbar}>
				<Toolbar className={classes.topButtons}>
					<MobileView>
						<Typography
							type="body1"
							component="div"
							className={classes.mobileStepIndicator}
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML('Step 2 of 4'),
							}}
						/>
					</MobileView>
					<BrowserView>
						<div className={classes.headerLogo}>
							<img alt="logo" id="header-logo-image" className={classes.logoImg} />
						</div>
					</BrowserView>
					<Button onClick={openCancelConfirmModal}>Cancel</Button>
					<Button variant="contained" color="primary" onClick={() => props.router.navigate('/TermsAndConditions')}>
						Continue
					</Button>
				</Toolbar>
			</div>
			<div className={classes.stepperToolbar}>
				<BrowserView>
					<Stepper className={classes.stepper} activeStep={1} alternativeLabel>
						<Step key={1}>
							<StepButton
								icon={<EditIcon color="primary" />}
								onClick={() =>
									props.router.navigate({
										pathname: '/ApplicationEntry',
										state: {
											update: true,
										},
									})
								}
							>
								<StepLabel>Personal Information</StepLabel>
							</StepButton>
						</Step>
						<Step key={2}>
							<StepButton>
								<StepLabel>Review</StepLabel>
							</StepButton>
						</Step>
						<Step key={3}>
							<StepButton>
								<StepLabel>Agreement</StepLabel>
							</StepButton>
						</Step>
						<Step key={4}>
							<StepButton>
								<StepLabel>Status</StepLabel>
							</StepButton>
						</Step>
					</Stepper>
				</BrowserView>
			</div>
			<div>
				<Paper elevation={6} className={classes.paper}>
					<div className={classes.paperDiv}>
						<Typography type="headline" gutterBottom>
							{settings.fieldAndFooterSettings.ApplicationReviewPageSettings.ReviewTitle}
						</Typography>
						<Typography type="subheading" component="div" className={classes.message}>
							<div
								// eslint-disable-next-line react/no-danger
								dangerouslySetInnerHTML={{
									__html: removeHTML(settings.fieldAndFooterSettings.ApplicationReviewPageSettings.ReviewText),
								}}
							/>
						</Typography>
					</div>
				</Paper>
			</div>
			<div className={classes.panelDiv}>
				<div className={classes.sectionDiv}>
					<Typography type="title" gutterBottom>
						Personal Information
					</Typography>
					<PersonalInformationFields disableAll settings={settings} />
				</div>
				{sectionNeeded(CURRENT_RESIDENCE_STATUS_FIELDS, PRIMARY_SETTING, settings) ? (
					<div className={classes.sectionDiv}>
						<Typography type="title" gutterBottom>
							Current Residence
						</Typography>
						<CurrentResidenceFields disableAll settings={settings} />
					</div>
				) : null}
				{sectionNeeded(PREVIOUS_RESIDENCE_STATUS_FIELDS, PRIMARY_SETTING, settings) ? (
					<div className={classes.sectionDiv}>
						<Typography type="title" gutterBottom>
							Previous Residence
						</Typography>
						<PreviousResidenceFields disableAll settings={settings} />
					</div>
				) : null}
				{sectionNeeded(CURRENT_EMPLOYMENT_STATUS_FIELDS, PRIMARY_SETTING, settings) ? (
					<div className={classes.sectionDiv}>
						<Typography type="title" gutterBottom>
							Current Employment
						</Typography>
						<CurrentEmploymentFields disableAll settings={settings} formValues={formValues} />
					</div>
				) : null}
				{sectionNeeded(PREVIOUS_EMPLOYMENT_STATUS_FIELDS, PRIMARY_SETTING, settings) ? (
					<div className={classes.sectionDiv}>
						<Typography type="title" gutterBottom>
							Previous Employment
						</Typography>
						<PreviousEmploymentFields disableAll settings={settings} />
					</div>
				) : null}
				{sectionNeeded(PERSONAL_REFERENCE_STATUS_FIELDS, PRIMARY_SETTING, settings) ? (
					<FieldArray
						classes={classes}
						name={PERSONAL_REFERENCES}
						component={renderReferences}
						settings={settings}
					/>
				) : null}
				{applicantIndicator === APP_TYPE_CUSTOMER_JOINT ? (
					<div>
						<div className={classes.sectionDiv}>
							<Typography type="title" gutterBottom>
								Co-Applicant: Personal Information
							</Typography>
							<CoAppPersonalInformationFields disableAll settings={settings} />
						</div>
						{sectionNeeded(COAPP_CURRENT_RESIDENCE_STATUS_FIELDS, COAPP_SETTING, settings) ? (
							<div className={classes.sectionDiv}>
								<Typography type="title" gutterBottom>
									Co-Applicant: Current Residence
								</Typography>
								<CoAppCurrentResidenceFields disableAll settings={settings} />
							</div>
						) : null}
						{sectionNeeded(COAPP_CURRENT_EMPLOYMENT_STATUS_FIELDS, COAPP_SETTING, settings) ? (
							<div className={classes.sectionDiv}>
								<Typography type="title" gutterBottom>
									Co-Applicant: Current Employment
								</Typography>
								<CoAppCurrentEmploymentFields disableAll settings={settings} />
							</div>
						) : null}
					</div>
				) : null}
			</div>
			<MobileView>
				<Fab
					color="primary"
					className={classes.editButtonMobile}
					onClick={() =>
						props.router.navigate({
							pathname: '/ApplicationEntry',
							state: {
								update: true,
							},
						})
					}
				>
					<EditIcon />
				</Fab>
			</MobileView>
			<BrowserView>
				<Fab
					color="primary"
					className={classes.editButton}
					onClick={() =>
						props.router.navigate({
							pathname: '/ApplicationEntry',
							state: {
								update: true,
							},
						})
					}
				>
					<EditIcon />
				</Fab>
			</BrowserView>
		</form>
	) : null;
}

ApplicationReview.propTypes = {
	classes: PropTypes.shape({
		flexContainer: PropTypes.string,
		leftItem: PropTypes.string,
	}).isRequired,
	formValues: PropTypes.shape({}),
	openCancelConfirmModal: PropTypes.func.isRequired,
	setApplicationFormData: PropTypes.func.isRequired,
	applicantIndicator: PropTypes.string.isRequired,
	userConsented: PropTypes.bool.isRequired,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		coApp: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		comboFields: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.arrayOf(
					PropTypes.shape({ displayText: PropTypes.string, value: PropTypes.string }),
				),
				PropTypes.number,
			]),
		),
		comboFieldsByValue: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.objectOf(
					PropTypes.shape({
						displayOrder: PropTypes.number,
						fieldName: PropTypes.string,
						displayText: PropTypes.string,
						returnValue: PropTypes.string,
						requiresEmploymentData: PropTypes.bool,
					}),
				),
				PropTypes.number,
			]),
		),
	}),
};

ApplicationReview.defaultProps = {
	settings: undefined,
	formValues: {},
};

export default withRouter(withStyles(styles, { name: 'ApplicationReview' })(ApplicationReview));
export { renderReferences }; // for testing purposes only
